export default __webpack_public_path__ + "static/media/money.93a93ce9.svg";